import gql from "graphql-tag";

export const loginPopupFragment = gql`
  fragment LoginPopupFragment on LoginPopup {
    id
    title
    coupon
    Button
    pcUrl
    mbUrl
    pcThumbnail
    mbThumbnail
    couponCode
    couponCodes
    couponValue
    buttonValue
    couponText
    buttonText
    buttonTextColor
    buttonBackgroudColor
    buttonBorderColor
    textColor
    popupType
    subTitle
    isEnable
    isAffUse
    pcSuccessful
    mbSuccessful
    successfulLink
    pcSuccessfulLinkTarget
    mbSuccessfulLinkTarget
    popupUpMinutes

    vouchers {
      id
      code
      name
    }
  }
`;
